import React, { useState, Fragment, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import DateField from '../../shared/components/form/DateField';
import MonthField from '../../shared/components/form/MonthField';
import Select from '../../shared/components/form/Select';
import validate from './components/Validate';
import {
  AVAILABLE_TO,
  REPORT_TYPES,
  STUDENT_AGREEMENT_ALL,
} from '../../shared/utils/constants';
import renderCheckBoxField from '../../shared/components/form/CheckBox';
import SelectVirtualized from '../../shared/components/form/SelectVirtualized';
import YearField from '../../shared/components/form/YearField';
import AvailableToSelector from '../CommunicationChannel/components/AvailableToSelector';

const ReportParameters = (props) => {
  const {
    t,
    students,
    classes,
    surveys,
    items,
    handleSubmit,
    type,
    backHandler,
    change,
    responsibleFinancial,
    loadResponsibleFinancial,
    loadStudentsByFilter,
    years,
    contracts,
    allResponsibleFinancial,
    subjects,
    allCourse,
    allSteps,
    loadAllSteps,
    allEmployees,
  } = props;
  const [startDate, setStartDate] = useState(new Date());

  const onDetailedChange = (event) => {
    if (
      type === REPORT_TYPES.RELA_PREALU ||
      type === REPORT_TYPES.RELA_PREALUDETAIL
    ) {
      if (event) {
        if (!event.currentTarget.checked) {
          change('type', REPORT_TYPES.RELA_PREALUDETAIL);
          change('detailed', event.currentTarget.checked);
        } else {
          change('type', REPORT_TYPES.RELA_PREALU);
          change('detailed', event.currentTarget.checked);
        }
      }
    }
  };

  const loadStudentsBySchoolClass = (schoolClass) => {
    if (schoolClass) {
      loadStudentsByFilter({
        id: 0,
        classes: Array.of(schoolClass),
        responsibles: [],
        menus: [],
        onlyActive: true,
      });
    }
  };

  const loadStudentsByActiveChecked = (checked) => {
    loadStudentsByFilter({
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: checked,
    });
  };

  useEffect(() => {
    if (type === REPORT_TYPES.RELA_ANIVER) {
      change('availableTo', AVAILABLE_TO.ONLY_STUDENTS);
    }
  }, [type]);

  const filterForStudentAttendance = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
                value={startDate}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Label className="generic__label">{t('general.detailed')}</Label>
            <Field
              name="detailed"
              component={renderCheckBoxField}
              className="colored-click"
              onChange={(event) => onDetailedChange(event)}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByStudentClassInitialFinalDate = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
                value={startDate}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByClassStudentDate = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.date')}</span>
          <div className="form__form-group-field">
            <Field
              name="date"
              component={DateField}
              onChange={(date) => setStartDate(date)}
            />
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByClassStudent = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.students')}
            />
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByClassInitialFinalDate = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterBySurvey = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('report.parameters.survey')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="survey"
              type="text"
              component={Select}
              options={surveys}
              placeholder={t('report.parameters.survey')}
            />
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByYear = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.year')}</span>
          <div className="form_form-group-field">
            <Field
              name="year"
              maxDate={new Date(9999, 12, 31)}
              component={YearField}
              placeholder={t('general.placeholders.year')}
              onChange={(date) => setStartDate(date)}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByMonth = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.placeholders.month')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="month"
              component={MonthField}
              placeholder={t('general.placeholders.month')}
              onChange={(date) => setStartDate(date)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.print')}</span>
          <div className="form__form-group-field">
            <Field name="availableTo" component={AvailableToSelector} t={t} />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByClassStudentDateAndItem = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.students')}
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.item')}</span>
          <div className="form_form-group-field">
            <Field
              name="item"
              type="text"
              component={Select}
              options={items}
              placeholder={t('general.placeholders.select-item')}
            />
          </div>
        </div>

        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterAnnualDebtSettlement = () => {
    const studentsWithoutAll = students.filter((student) => student.id);
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field
              name="onlyActive"
              defaultChecked
              component={renderCheckBoxField}
              className="colored-click"
              onChange={({ target }) => {
                if (target) {
                  loadStudentsByActiveChecked(target.checked);
                }
              }}
            />
            <span className="form__form-group-label pr-3">
              {t('general.active-students-only')}
            </span>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="students"
              component={SelectVirtualized}
              options={studentsWithoutAll}
              defaultValue
              onChange={(value) => loadResponsibleFinancial(value.id)}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.responsible-account')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="responsibleFinancial"
              component={Select}
              options={responsibleFinancial}
              placeholder={t('general.responsible-account')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.year')}</span>
          <div className="form_form-group-field">
            <Field
              name="year"
              component={Select}
              options={years}
              placeholder={t('general.year')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByInitialFinalDate = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByStudentResponsibleContract = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              onChange={(value) => loadResponsibleFinancial(value.id)}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.responsible-account')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="responsibles"
              type="text"
              component={Select}
              options={responsibleFinancial}
              placeholder={t('general.responsible-account')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.contract')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="contract"
              component={Select}
              type="text"
              placeholder={t('general.contract')}
              options={contracts}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByInitialFinalDateClassSubject = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.class')}</span>
          <div className="form__form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              onChange={loadStudentsBySchoolClass}
              placeholder={t('general.class')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.student')}</span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              component={Select}
              options={students}
              placeholder={t('general.student')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('communication.subject')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="subjects"
              type="text"
              component={Select}
              options={subjects}
              placeholder={t('communication.subject')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterDailyClassReport = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('communication.subject')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="subjects"
              type="text"
              component={Select}
              options={subjects}
              isClearable={false}
              placeholder={t('communication.subject')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.class')}</span>
          <div className="form__form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              isClearable={false}
              placeholder={t('general.class')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.course')}</span>
          <div className="form__form-group-field">
            <Field
              name="coursenames"
              type="text"
              component={Select}
              options={allCourse}
              isClearable={false}
              defaultValue
              onChange={(value) => loadAllSteps(value.id)}
              placeholder={t('general.course')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.course-step')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="allSteps"
              type="text"
              component={Select}
              options={allSteps}
              isClearable={false}
              placeholder={t('general.course-step')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.employees')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="allEmployees"
              type="text"
              component={Select}
              isClearable={false}
              options={allEmployees}
              placeholder={t('general.employees')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByClassAndAgreement = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.agreement')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="agreement"
              type="text"
              component={Select}
              options={STUDENT_AGREEMENT_ALL(t)}
              placeholder={t('general.agreement')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByStudents = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="classesnames"
              type="text"
              component={Select}
              options={classes}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const filterByDueDateAndInitialFinalDate = () => {
    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.payday')}</span>
          <div className="form_form-group-field">
            <Field
              name="payday"
              component={DateField}
              onChange={(date) => setStartDate(date)}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                minDate={startDate}
                startDate={startDate}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  };

  const loadParameters = () => {
    if (
      type === REPORT_TYPES.RELA_TROCAS ||
      type === REPORT_TYPES.RELA_SONECA ||
      type === REPORT_TYPES.RELA_IMCIDA ||
      type === REPORT_TYPES.RELA_ALIMEN ||
      type === REPORT_TYPES.RELA_MEDICA ||
      type === REPORT_TYPES.RELA_SMRTGO
    ) {
      return filterByStudentClassInitialFinalDate();
    }
    if (type === REPORT_TYPES.RELA_PREALU) {
      return filterForStudentAttendance();
    }
    if (
      type === REPORT_TYPES.RELA_DIARIO ||
      type === REPORT_TYPES.RELA_ANALIP ||
      type === REPORT_TYPES.RELA_DIARES
    ) {
      return filterByClassStudentDate();
    }
    if (
      type === REPORT_TYPES.RELA_CRESCI ||
      type === REPORT_TYPES.RELA_ALTIDA ||
      type === REPORT_TYPES.RELA_PESIDA ||
      type === REPORT_TYPES.RELA_ALIMFI
    ) {
      return filterByClassStudent();
    }
    if (type === REPORT_TYPES.RELA_ALUTUR) {
      return filterByClassInitialFinalDate();
    }
    if (
      type === REPORT_TYPES.RELA_ALURES ||
      type === REPORT_TYPES.RELA_CARTAO ||
      type === REPORT_TYPES.RELA_ATEFRE
    ) {
      return filterByClassStudent();
    }

    if (type === REPORT_TYPES.RELA_COPEAU) {
      return filterBySurvey();
    }
    if (type === REPORT_TYPES.RELA_ANIVER) {
      return filterByMonth();
    }
    if (type === REPORT_TYPES.RELA_COVIDF) {
      return filterByClassStudentDateAndItem();
    }
    if (type === REPORT_TYPES.RELA_QUDE) {
      return filterAnnualDebtSettlement();
    }

    if (type === REPORT_TYPES.RELA_SPAYR) {
      return filterByInitialFinalDate();
    }

    if (type === REPORT_TYPES.RELA_CONTMOV) {
      return filterByStudentResponsibleContract();
    }

    if (type === REPORT_TYPES.RELA_TARE) {
      return filterByInitialFinalDateClassSubject();
    }
    if (type === REPORT_TYPES.RELA_CLASS_DIARY) {
      return filterDailyClassReport();
    }
    if (type === REPORT_TYPES.RELA_STUDENT_AGREEMENT) {
      return filterByClassAndAgreement();
    }
    if (type === REPORT_TYPES.RELA_ALUNOS) {
      return filterByStudents();
    }
    if (type === REPORT_TYPES.RELA_CALEAN) {
      return filterByYear();
    }
    if (type === REPORT_TYPES.RELA_ACCOUNTS_RECEIVABLE) {
      return filterByDueDateAndInitialFinalDate();
    }

    return null;
  };

  useEffect(() => {
    loadParameters();
    change('initialDate', startDate);
    change('finalDate', startDate);
    change('payday', startDate);
    change('date', startDate);
    change('month', startDate);
    change('agreement', STUDENT_AGREEMENT_ALL(t)[2]);
  }, []);

  useEffect(() => {
    if (items.length) {
      change('item', items[0]);
    }
  }, [items]);

  useEffect(() => {
    if (type) {
      change('type', type);
      change('detailed', true);
    }
  }, [type]);

  useEffect(() => {
    change('classesnames', classes[0]);
  }, [classes]);

  useLayoutEffect(() => {
    if (type !== REPORT_TYPES.RELA_QUDE) {
      change('students', students[0]);
      change('responsibles', allResponsibleFinancial[0]);
      change('contract', contracts[0]);
      change('subjects', subjects[0]);
      change('coursenames', allCourse[0]);
      change('allSteps', allSteps[0]);
      change('allEmployees', allEmployees[0]);
    }
  }, [classes, students, contracts, allResponsibleFinancial, subjects]);

  return <Fragment>{loadParameters()}</Fragment>;
};

ReportParameters.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  students: PropTypes.arrayOf(PropTypes.shape).isRequired,
  classes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  surveys: PropTypes.arrayOf(PropTypes.shape).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
  years: PropTypes.arrayOf(PropTypes.shape).isRequired,
  responsibleFinancial: PropTypes.arrayOf(PropTypes.shape).isRequired,
  allResponsibleFinancial: PropTypes.arrayOf(PropTypes.shape).isRequired,
  loadResponsibleFinancial: PropTypes.func.isRequired,
  loadStudentsByFilter: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  contracts: PropTypes.arrayOf(PropTypes.shape).isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape).isRequired,
  allCourse: PropTypes.arrayOf(PropTypes.shape).isRequired,
  loadAllSteps: PropTypes.func.isRequired,
  allSteps: PropTypes.arrayOf(PropTypes.shape).isRequired,
  allEmployees: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'ReportParameters',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(ReportParameters));
